import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getMe, type MeResponse } from '@Shared/profile/profile.service';
import { AuthContext } from '../contexts/auth/auth.context';

interface UseProfileResult {
  data: MeResponse | null;
  loading: boolean;
  error: string | null;
}

export function useProfile(): UseProfileResult {
  const { claims } = useContext(AuthContext);
  const employeeId = claims.employeeid;

  const { data, isLoading, error } = useQuery({
    queryKey: ['me', employeeId],
    queryFn: () => getMe(employeeId),
    staleTime: 5 * 60 * 1000,
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Error desconocido' : null,
  };
}
